export enum EAuthenticationStepType {
  VerifyQna = 'VerifyQna',
  VerifySms = 'VerifySms',
  TrackingConsent = 'TrackingConsent',
  GdprConsent = 'GdprConsent',
  IdentifyRecipient = 'IdentifyRecipient',
}
